import { createSelector, createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { RootState } from '.'

export type Bill = {
  id: string
  category: string
  amount: number
  currency: string
  breakdown: string
  remaining: number
  proposalid: string
  invoices: string[]
}

export type BillState = {
  bills: Bill[]
}

const initialState: BillState = {} as BillState

export const billSlice = createSlice({
  name: 'bill',
  initialState,
  reducers: {
    setBills: (state, action: PayloadAction<BillState>) => {
      return action.payload
    },
    upsertBill: (state, action: PayloadAction<Bill>) => {
      const { id } = action.payload
      const index = state.bills.findIndex((bill) => bill.id === id)
      if (index >= 0) {
        state.bills[index] = action.payload
      } else {
        state.bills.push(action.payload)
      }
    },
    removeBill: (state, action: PayloadAction<string>) => {
      state.bills = state.bills.filter((bill) => bill.id !== action.payload)
    },
  },
})

export const { setBills, upsertBill, removeBill } = billSlice.actions

export const selectAllBills = (state: RootState): BillState => {
  return state[billSlice.name]
}

export const selectBillById = createSelector(
  [selectAllBills, (_, id: string) => id],
  (allBills, id): Bill | undefined => {
    return allBills.bills.find((bill) => bill.id === id)
  },
)
